import React, { Fragment } from 'react';
import { Section } from './ProductPage';
import { styled } from 'linaria/react';
import t from '@jetshop/intl';
import ImageSlider from './ImageSlider/ImageSlider';
import { Header, PriceWrapper, ProductHeading } from './ProductDetails';
import { Favourite } from '../ProductList/Favourite';
import { Brand } from './Brand/Brand';
import { ProductInfoMarginBottom } from './StyledComponents';
import { GridPrice as Price } from '../Price';
import { BuyButton, buyHeightStyle } from './AddToCart/AddToCartWrapper';

const LoadingLine = styled.div`
  max-width: 100%;
  width: 100%;
  background: #f5f5f5;
  ${ProductInfoMarginBottom}
`;

const BuyArea = styled.div`
  display: flex;
  margin-top: 1rem;
  .input-selector {
    ${buyHeightStyle}
  }
`;

export default function ProductPageLoadingState({ product }) {
  if (!product) return null;
  return (
    <Fragment>
      <Section className="product-images-wrapper">
        <ImageSlider product={product} />
      </Section>
      <Section className="product-info-wrapper">
        <Header>
          <LoadingLine
            style={{ marginBottom: '10px', height: '20px', width: '300px' }}
          />
          <ProductHeading data-testid="product-title">
            {product.name}
            <Favourite product={product} />
          </ProductHeading>
          <Brand subName={product.subName} />
        </Header>
        <LoadingLine style={{ height: '15px', width: '800px' }} />
        <LoadingLine style={{ height: '15px', width: '300px' }} />
        <LoadingLine style={{ height: '50px', margin: '2rem 0 1rem' }} />
        <PriceWrapper>
          <Price price={product.price} previousPrice={product.previousPrice} />
        </PriceWrapper>
        <BuyArea>
          <LoadingLine className="input-selector" style={{ width: '90px' }} />
          <BuyButton>{t('Add to cart')}</BuyButton>
        </BuyArea>
      </Section>
    </Fragment>
  );
}
